import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import createReducer from "./rootReducer";

if (process.env.NODE_ENV === "development" && module.hot) {
	module.hot.accept("./rootReducer", () => {
		const newRootReducer = require("./rootReducer").default;
		store.replaceReducer(newRootReducer.createReducer());
	});
}

const middlewares = [];

const persistConfig = {
	key: "corksy",
	storage: storageSession,
	whitelist: ["auth"], // which reducer want to store
};

if (process.env.NODE_ENV === "development") {
	const { createLogger } = require(`redux-logger`);
	const logger = createLogger({
		collapsed: (getState, action, logEntry) => !logEntry.error,
	});

	middlewares.push(logger);
}

const store = configureStore({
	reducer: persistReducer(persistConfig, createReducer()),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === "development",
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(createReducer(store.asyncReducers));
	return store;
};

export const persistor = persistStore(store);

export default store;
